import {SxProps} from '@mui/material';

export const STYLES = {
  stepper: {
    '& .MuiStepConnector-root': {
      position: 'relative',
      ml: 0,
      mr: '19px',
      height: '45px',
      overflow: 'hidden',

      '&:first-child': {
        height: '18px',
      },

      '& .MuiStepConnector-line': {
        position: 'absolute',
        top: 0,
        right: 0,
        height: '44px',
        borderColor: 'rgba(0, 0, 0, 0.1)',
      },
    },

    '& .MuiStepLabel-root': {
      p: 0,
      flexDirection: 'row-reverse',
      gap: '16px',

      '& .MuiStepLabel-iconContainer': {
        p: 0,
      },
    },

    '& .MuiStepLabel-labelContainer': {
      textAlign: 'end',

      '& .MuiStepLabel-label > .MuiStack-root': {
        gap: '20px',
      },
    },

    '& .MuiStep-root:last-child': {
      position: 'relative',

      '&::after': {
        content: '""',
        position: 'absolute',
        top: '100%',
        right: '19px',
        height: '18px',
        borderLeftStyle: 'solid',
        borderLeftWidth: '1px',
        borderColor: 'rgba(0, 0, 0, 0.1)',
      },
    },
  },

  stepLabel: {
    fontWeight: 600,
    fontSize: '18px',
    lineHeight: '22px',
    color: '#1E1E1E',
  },

  stepSubLabel: {
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '19px',
    color: '#263238',
    opacity: 0.6,
  },

  stepButton: {
    p: '2px 8px',
    borderRadius: '8px',
    flexDirection: 'column',
    alignItems: 'flex-end',
  },

  button: {
    textTransform: 'none',
    backgroundColor: '#0D99FF',

    '&:hover': {
      backgroundColor: '#0A80D4',
    },
  },

  icon: {
    color: '#263238',
  },

  stepIcon: {
    width: 40,
    height: 40,
    border: '1px solid #263238',
    borderRadius: '50%',
    backgroundColor: '#fff !important',
    color: '#263238',
  },

  stepIconActive: {
    borderColor: '#0039CE',
    backgroundColor: '#0D99FF !important',
    color: '#fff',
  },

  stepIconLabel: {
    fontWeight: 600,
    fontSize: '18px',
    lineHeight: '22px',
  },
  buttonSecondaryTitle: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: '13px',
    lineHeight: '20px',
    letterSpacing: '0.02em',
    textTransform: 'none',
    color: '#0C0C0D',
  },
  buttonSaveTitle: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: '13px',
    lineHeight: '20px',
    letterSpacing: '0.02em',
    textTransform: 'none',
    color: '#fff',
  },
  buttonSave: {
    boxShadow: 'unset',
    bgcolor: '#2CC378',
    p: '6px 4px',
    borderRadius: '6px',
  },
} as const satisfies SxProps;
